<div
  class="sb-field sb-date-range"
  [class.sb-field--disabled]="disabled()"
  role="group"
  [attr.aria-labelledby]="label() ? labelId() : null"
  [attr.aria-label]="label() ? null : ariaLabel() || null">
  @if (label() || showHelpAfterLabel()) {
  <div #labelRow class="sb-field__label-row">
    <span class="sb-date-range__label" [id]="labelId()">{{ label() }}</span>
    @if (showHelpAfterLabel()) {
    <app-info-popover class="sb-field__help sb-field__help--after-label" [info]="helpText()"></app-info-popover>
    }
  </div>
  }
  @if (description()) {
  <div class="sb-field__description" [id]="id() + '-description'">{{ description() }}</div>
  }
  <span class="visually-hidden" [id]="hintId()">{{ hint() }}</span>

  <div #groupEl class="sb-date-range__inputs" (focusout)="onFocusOut($event)" (keydown)="onKeydown($event)">
    @for (half of halves; track half) {
    <div class="sb-date-range__half">
      <div class="sb-field__control floating-label">
        <div
          class="sb-dt"
          [class.sb-dt--interactive]="interactive() && half === 'end'"
          [class.sb-dt--clearable]="interactive() && half === 'end' && hasValue()">
          <app-sb-date-time-field
            mode="date"
            [state]="stateOf(half)"
            (stateChange)="setState(half, $event)"
            [fieldId]="id() + '-' + half"
            [nameId]="id() + '-' + half + '-label' + (label() ? ' ' + labelId() : '')"
            [describedBy]="describedBy(half)"
            [invalid]="!!errorFor(half)"
            [disabled]="disabled()"
            [zone]="timeZone()"
            (edited)="onEdited(half, $event)"
            (openRequested)="open($event)"></app-sb-date-time-field>
          <label [id]="id() + '-' + half + '-label'">{{ labelFor(half) }}</label>
          @if (interactive() && half === 'end') {
          <span class="sb-dt__actions">
            @if (hasValue()) {
            <button
              type="button"
              class="sb-input-clear sb-dt__clear"
              tabindex="-1"
              title="Clear"
              [attr.aria-label]="'Clear ' + (label() || ariaLabel() || 'dates')"
              (click)="clear()">
              &times;
            </button>
            }
            <button
              #triggerEl
              type="button"
              class="sb-dt__trigger"
              aria-haspopup="dialog"
              [attr.aria-label]="triggerLabel()"
              [attr.aria-expanded]="isOpen()"
              [attr.aria-controls]="isOpen() ? panelId() : null"
              (click)="onTriggerClick($event)">
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z"/></svg>
            </button>
          </span>
          }
        </div>
      </div>
      @if (errorFor(half)) {
      <div class="bar error-brd sb-field__error" [id]="id() + '-' + half + '-error'">
        <div class="invalid-text">{{ errorFor(half) }}</div>
      </div>
      } @else if (noticeFor(half)) {
      <div class="sb-field__notice">{{ noticeFor(half) }}</div>
      }
    </div>
    }
  </div>

  @if (groupError()) {
  <div class="bar error-brd sb-field__error" [id]="id() + '-error'">
    <div class="invalid-text">{{ groupError() }}</div>
  </div>
  }
</div>

<ng-template #panelTpl>
  <app-sb-date-time-panel
    mode="range"
    [panelId]="panelId()"
    [label]="label() || ariaLabel()"
    [rangeStart]="startParts()"
    [rangeEnd]="endParts()"
    [min]="minDay()"
    [max]="maxDay()"
    [zone]="timeZone()"
    [picks]="picks()"
    [showClear]="hasValue()"
    [narrow]="narrow()"
    (mousedown)="onPanelMouseDown($event)"
    (focusout)="onFocusOut($event)"
    (rangeChosen)="onRangeChosen($event)"
    (pickChosen)="onPresetChosen($event)"
    (cleared)="clear()"
    (escaped)="close(true)"
    (tabbedOut)="onTabbedOut($event)">
  </app-sb-date-time-panel>
</ng-template>
